<template>
  <div style="margin-top: -50px; background: #f3f3f5">
    <sk-nonsupport-i18n></sk-nonsupport-i18n>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'no-login-layouts',
}
</script>
